// extracted by mini-css-extract-plugin
export default {"tooltip":"cancelTooltip_tooltip__fl7Q4","help":"cancelTooltip_help__+CZSy","arrow":"cancelTooltip_arrow__S4x6q"};